import { Component, OnInit } from '@angular/core';
import { Desk } from 'projects/qcloud-models/desk/desk';
import { CategoryService } from 'projects/qcloud-rest-client/src/lib/category.service';
import { DeskService } from 'projects/qcloud-rest-client/src/lib/desk.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CategoryTable } from 'projects/qcloud-models/category/category-table.model';
import { ChangesTrackerService } from '../../shared/changes-tracker.service';
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  selectedCategoryId: number;
  categoryTable: CategoryTable[];
  desks: Desk[];

  constructor(private categoryService: CategoryService, private deskService: DeskService,
    private translate: TranslateService, private toastr: ToastrService, private changesTracker: ChangesTrackerService) { }

  ngOnInit(): void {
    this.getCategories();
  }

  getCategories() {
    this.categoryService.getCategories((categories) => {
      this.categoryTable = categories.map(category => new CategoryTable(category, this.deskService));
      var change = this.changesTracker.getChangedEntity("category");
      if (change) {
        this.categoryTable.find(x => (x.id).toString() == change.id).isChanged = true;
      }
      this.changesTracker.navigateToChangedEntity(document);

    },
      () => { });
  }

  onDeleteConfirm(confirmed: boolean) {
    if (confirmed) {
      this.deleteCategory(this.selectedCategoryId);
    }
  }

  deleteCategory(categoryId: number) {
    this.categoryService.deleteCategory(categoryId).subscribe(
      res => {
        this.getCategories();
      },
      err => {
        this.translate.get('delete-error').subscribe((error: string) => {
          this.translate.get('repeat').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }

}
